import { NgModule } from '@angular/core';
import { FinancialToolComponent } from './financial-tool.component';
import { FinancialToolPayoutComponent } from './payout/payout.component';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '@shared/shared.module';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { FinancialToolGeneralComponent } from './general/general.component';
import { FinancialToolCorporatePaymentsComponent } from './corporate-payments/corporate-payments.component';

@NgModule({
  declarations: [
    FinancialToolComponent,
    FinancialToolPayoutComponent,
    FinancialToolGeneralComponent,
    FinancialToolCorporatePaymentsComponent,
  ],
  imports: [
    SharedModule,
    MatDialogCustomModule,
    CurrencyCountryPipeModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    // MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    FinancialToolComponent,
    FinancialToolPayoutComponent,
    FinancialToolGeneralComponent,
    FinancialToolCorporatePaymentsComponent,
  ],
})
export class DialogFinancialToolsModule {}
